import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useMemo } from "react"
import React from "react"
import {
    PhotoTour,
    PhotoTourItem,
    PhotoTourItemSampleImage,
    usePhotoTourByCleaningId
} from "../../../hooks/usePhotoTour"

// CleaningInfopage/providersにもphotoTourのContextがあるので共通化できそうだったらしたい
export interface PhotoTourContextState {
    cleaningId: string
    tour?: PhotoTour
    items?: PhotoTourItem[]
    sampleImagesMap?: Record<string, PhotoTourItemSampleImage[]>
}

const PhotoTourContext = React.createContext<PhotoTourContextState | undefined>(
    undefined
)

export const PhotoTourProvider = ({
    cleaningId,
    children
}: React.PropsWithChildren<{ cleaningId: string }>) => {
    const { token } = useAuth()
    const { data } = usePhotoTourByCleaningId(token, cleaningId)

    const value = useMemo(
        () => ({
            cleaningId,
            tour: data?.photoTour,
            items: data?.items,
            sampleImagesMap: data?.sampleImagesMap
        }),
        [cleaningId, data?.items, data?.photoTour, data?.sampleImagesMap]
    )

    return (
        <PhotoTourContext.Provider value={value}>
            {children}
        </PhotoTourContext.Provider>
    )
}

export const usePhotoTourContext = () => {
    const ctx = React.useContext(PhotoTourContext)
    if (!ctx) {
        throw new Error(
            "useCleaningPhotoTourContext must be used within a CleaningPhotoTourProvider"
        )
    }

    return ctx
}
